import React from 'react';
import addCountToString from '../../../utils/addCountToString';
import BasePillSelect, { PillOption } from '../../v2BaseComponents/Inputs/PillSelect';
import Stack, { contentStackSpacing } from '../../v2BaseComponents/Stack';
import Text from '../../v2BaseComponents/Text';

export type Option<TValue> = {
    label: string;
    value: TValue;
    count?: number;
};

export type ToggleFilterOwnProps<TValue extends string> = {
    value: TValue | null;
    onChange: (value: TValue | null) => void;
    options: Option<TValue>[];
    onClear?: () => void;
    title: string;
};

export type ToggleFilterProps<TValue extends string> = ToggleFilterOwnProps<TValue>;

function ToggleFilter<TValue extends string>(props: ToggleFilterProps<TValue>) {
    const pillOptions: PillOption[] = props.options.map((option) => ({
        label: option.count === undefined ? option.label : addCountToString(option.label, option.count),
        value: option.value,
    }));
    return (
        <Stack vertical space={contentStackSpacing} fullWidth align="flex-start">
            <Text variant="h6">{props.title}</Text>
            <BasePillSelect
                options={pillOptions}
                value={props.value}
                onChange={(value) => props.onChange(value as TValue)}
                pillContainerStyle={{ flexWrap: 'wrap', rowGap: 5 }}
            />
        </Stack>
    );
}

export default ToggleFilter;
